export default {"src":"/_next/static/media/icon_tell1.86f27f92.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};